export default "__VITE_ASSET__DsX5bREh__"